import SettingsOutlined from '@mui/icons-material/SettingsOutlined';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import CampaignIcon from '@mui/icons-material/Campaign';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';
import PersonOutlined from '@mui/icons-material/PersonOutlined';
import { SvgIconComponent } from '@mui/icons-material';

export type MenuItemId = 'staff' | 'myDetails' | 'gettingStarted' | 'releaseNotes' | 'signOut';

export interface MenuItemConfig {
  id: MenuItemId;
  label: string;
  icon: SvgIconComponent;
  /** if true, item requires is_dianomi user */
  requiresDianomi?: boolean;
  /** if true, item only shows for client accounts */
  requiresClient?: boolean;
  /** if provided, the path template with placeholders */
  pathTemplate?: string;
}

/**
 * shared menu items configuration used by mobile Sidebar and AdminUserLinks
 * single source of truth for account menu items
 */
export const accountMenuItems: MenuItemConfig[] = [
  {
    id: 'staff',
    label: 'Staff Dashboard',
    icon: SettingsOutlined,
    requiresDianomi: true,
    pathTemplate: '/staff',
  },
  {
    id: 'myDetails',
    label: 'My Details',
    icon: PersonOutlined,
    pathTemplate: '/user-profile',
  },
  {
    id: 'gettingStarted',
    label: 'Getting Started',
    icon: InfoOutlined,
    requiresClient: true,
    pathTemplate: '/:accountType/:accountId/getting-started',
  },
  {
    id: 'releaseNotes',
    label: 'Release Notes',
    icon: CampaignIcon,
  },
  {
    id: 'signOut',
    label: 'Sign Out',
    icon: LogoutOutlined,
  },
];

/**
 * build path from a template, replacing :accountType and :accountId placeholders
 */
export function buildMenuItemPath(
  pathTemplate: string,
  accountType: string,
  accountId: string,
): string {
  return pathTemplate.replace(':accountType', accountType).replace(':accountId', accountId);
}

/**
 * filter menu items based on user context
 */
export function getVisibleMenuItems(
  items: MenuItemConfig[],
  context: {
    isDianomi: boolean;
    isClientAccount: boolean;
    currentPath: string;
  },
): MenuItemConfig[] {
  return items.filter((item) => {
    // staff item: only show for dianomi users not already on staff page
    if (item.requiresDianomi) {
      return context.isDianomi && !context.currentPath.startsWith('/staff');
    }
    // getting started: only show for client accounts
    if (item.requiresClient) {
      return context.isClientAccount;
    }
    return true;
  });
}
